import React from 'react';

import InfluenceMLogo from '../../../../components/Widgets/InfluenceMLogo';
import SalesLogo from '../../../../components/Widgets/SalesLogo';
import {useTheme} from '@material-ui/styles';

type AdminLogoProps = {
  height: number;
};

const AdminLogo = ({height}: AdminLogoProps): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 902.92 277.93"
      style={{
        width: '100%',
        height: height,
      }}
    >
      <defs>
        <style>
          {`
          .cls-1 {
            fill: ${theme.palette['main-green-cta']};
          }
          .cls-2 {
            fill: ${theme.palette['main-indigo']};
          }
          .cls-3 {
            fill: #ffffff;
            stroke: ${theme.palette['main-indigo']};
            stroke-miterlimit: 10;
            stroke-width: 4px;
          }
        `}
        </style>
      </defs>
      <g id="Layer_2-2" data-name="Layer 2">
        <g>
          <path className="cls-3" d="M2,274.29v-116.49h26.74v116.49H2Z" />
          <path
            className="cls-3"
            d="M193.47,157.8h25.76v116.49h-23.79l-51.68-72.35v72.35h-25.76v-116.49h23.79l51.68,72.35v-72.35h0Z"
          />
          <path
            className="cls-3"
            d="M384.45,180.93h-49.71v24.77h46.27v22.97h-46.27v45.61h-26.25v-116.49h75.96v23.13h0Z"
          />
          <path
            className="cls-3"
            d="M463.03,274.29v-116.49h26.74v93.03h50.37l-1.64,23.46h-75.47Z"
          />
          <path
            className="cls-3"
            d="M690.6,157.8h26.58l.33,63c0,11.05-2.08,20.73-6.23,29.04-4.16,8.31-10.06,14.74-17.72,19.28s-16.68,6.81-27.07,6.81c-17.28,0-30.38-4.27-39.29-12.8-8.92-8.53-13.37-21.27-13.37-38.23v-67.1h26.74v64.97c0,10.39,2.24,17.88,6.73,22.48,4.48,4.59,10.77,6.89,18.87,6.89s14.14-2.65,18.46-7.96c4.32-5.3,6.42-13.59,6.32-24.86l-.33-61.53h-.02Z"
          />
          <path
            className="cls-3"
            d="M823.16,274.29h-29.53l38.56-58.9-36.42-57.59h30.19l21.66,34.95,21.49-34.95h28.71l-36.59,56.28,38.06,60.21h-30.68l-22.15-36.92-23.3,36.92h0Z"
          />
          <circle className="cls-2" cx="480.97" cy="46.18" r="46.18" />
          <circle className="cls-2" cx="667.23" cy="46.18" r="46.18" />
          <circle className="cls-1" cx="853.12" cy="46.19" r="46.18" />
        </g>
      </g>
    </svg>
  );
};

const HeaderLogo = ({height = 50}): JSX.Element => {
  return <AdminLogo height={height} />;
};

export default HeaderLogo;
